// libraries
import gapi from 'gapi';
import $ from 'jquery';

const GoogleOAuth = {};

// Authenticates a user with Google's API if the user has not already done so.
// If a user has already authorized RaiseMe to use Google's API, the user won't
// won't see Google's OAuth window.
GoogleOAuth.connect = (scope, discoveryDocs) => {
  const promise = $.Deferred();

  GoogleOAuth.signInAlreadyAuthorizedUser(scope, (response) => {
    if (response.access_token) {
      promise.resolve(response);
    } else {
      GoogleOAuth.authorize(scope, discoveryDocs).then((response) => {
        promise.resolve(response);
      }, (err) => {
        promise.reject(err);
      });
    }
  });

  return promise;
};

GoogleOAuth.init = (scope, discoveryDocs = [], cb = () => {}) => {
  if (Array.isArray(scope)) {
    scope = scope.join(' ');
  }

  gapi.load('auth2', () => {
    if (!gapi.auth2.getAuthInstance()) {
      gapi.auth2.init({
        clientId: window.GOOGLE_CLIENT_ID,
        scope,
        discoveryDocs
      });
      cb();
    }
  });
};

// Accepts a scope and discoveryDocs arguments and prompts user to connect gmail account
// and authorize the requested permissions (scope)
//
// scope can be a string or an array of Google API scopes
// discoveryDocs is an array of Google API discovery docs urls, it is optional
GoogleOAuth.authorize = () => {
  const promise = $.Deferred();

  gapi.auth2.getAuthInstance().signIn({prompt: 'select_account'}).then((googleUser) => {
    promise.resolve(googleUser);
  }).catch((errors) => {
    promise.reject(errors);
  });

  return promise;
};

// Accepts a scope and a callback to call with the results of authorizing the user
// Will authorize the user if they are logged into a gmail account that they have previously
// authorized all of the scope permissions with, otherwise the result will not have an access_token
//
// scope can be a string or an array of Google API scopes
// cb is a callback function that will be passed the results of authorizing with GoogleOAuth
GoogleOAuth.signInAlreadyAuthorizedUser = (scope, cb = () => {}) => {
  if (Array.isArray(scope)) {
    scope = scope.join(' ');
  }

  gapi.load('client:auth2', () => {
    gapi.auth2.authorize({
      client_id: window.GOOGLE_CLIENT_ID,
      scope,
      prompt: 'none'
    }, (result) => {
      cb(result);
    });
  });
};

GoogleOAuth.userConnected = () => {
  const promise = $.Deferred();

  gapi.load('client:auth2', () => {
    gapi.auth2.init({clientId: window.GOOGLE_CLIENT_ID});
    promise.resolve(gapi.auth2.getAuthInstance().isSignedIn.get());
  }, () => {
    promise.reject();
  });

  return promise;
};

export default GoogleOAuth;
